import React, { useEffect, useRef } from 'react'

const IndeterminateCheckbox = ({ indeterminate, ...rest }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate, rest.checked])

  return <input type="checkbox" ref={ref} className={'cursor-pointer'} {...rest} />
}

export default IndeterminateCheckbox
